import { render, staticRenderFns } from "./FindJobIntroduce.vue?vue&type=template&id=8b13a93a&scoped=true&"
import script from "./FindJobIntroduce.vue?vue&type=script&lang=js&"
export * from "./FindJobIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./FindJobIntroduce.vue?vue&type=style&index=0&id=8b13a93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b13a93a",
  null
  
)

export default component.exports